import { gsap, ScrollTrigger } from "../layout"

// custom library
import Choices from 'choices.js'
import axios from 'axios'

function choicesJs() {
    const sortElement = document.querySelector('#activity-sort')

    if (sortElement) {
        const choices = new Choices(sortElement, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }

    const area = document.querySelector('#area')

    if (area) {
        const choices = new Choices(area, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }

    const location = document.querySelector('#location')

    if (location) {
        const choices = new Choices(location, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }
}

function customRangeSlider() {
    // https://medium.com/@predragdavidovic10/native-dual-range-slider-html-css-javascript-91e778134816

    const fromSlider = document.querySelector('#fromSlider');
    const toSlider = document.querySelector('#toSlider');
    const fromInput = document.querySelector('#fromInput');
    const toInput = document.querySelector('#toInput');

    if (fromSlider) {
        function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
            const [from, to] = getParsed(fromInput, toInput);
            fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
            if (from > to) {
                fromSlider.value = to;
                fromInput.value = to;
            } else {
                fromSlider.value = from;
            }
        }
            
        function controlToInput(toSlider, fromInput, toInput, controlSlider) {
            const [from, to] = getParsed(fromInput, toInput);
            fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
            setToggleAccessible(toInput);
            if (from <= to) {
                toSlider.value = to;
                toInput.value = to;
            } else {
                toInput.value = from;
            }
        }
        
        function controlFromSlider(fromSlider, toSlider, fromInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
            if (from > to) {
                fromSlider.value = to;
                fromInput.value = to;
            } else {
                fromInput.value = from;
            }
        }
        
        function controlToSlider(fromSlider, toSlider, toInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
            setToggleAccessible(toSlider);
            if (from <= to) {
                toSlider.value = to;
                toInput.value = to;
            } else {
                toInput.value = from;
                toSlider.value = from;
            }
        }
        
        function getParsed(currentFrom, currentTo) {
            const from = parseInt(currentFrom.value, 10);
            const to = parseInt(currentTo.value, 10);
            return [from, to];
        }
        
        function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
            const rangeDistance = to.max-to.min;
            const fromPosition = from.value - to.min;
            const toPosition = to.value - to.min;
            controlSlider.style.background = `linear-gradient(
                to right,
                ${sliderColor} 0%,
                ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
                #FDB716 ${((fromPosition)/(rangeDistance))*100}%,
                #FDB716 ${(toPosition)/(rangeDistance)*100}%, 
                ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
                ${sliderColor} 100%)`;
        }
        
        function setToggleAccessible(currentTarget) {
            const toSlider = document.querySelector('#toSlider');
            if (Number(currentTarget.value) <= 0 ) {
                toSlider.style.zIndex = 2;
            } else {
                toSlider.style.zIndex = 0;
            }
        }
        
        fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
        setToggleAccessible(toSlider);
        
        fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
        toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
        fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
        toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);
    }
}

function removeFilter() {
    const buttonFilters = document.querySelectorAll('.list__filter-link')

    if (buttonFilters) {
        buttonFilters.forEach(bf => {
            bf.addEventListener('click', (e) => {
                e.preventDefault()
                // Get the current URL
                const currentUrl = window.location.href;

                const filter = bf.dataset.filter;

                const paramKeys = filter.split(',')

                // Create a URL object
                const url = new URL(currentUrl);

                // Loop through each parameter key and remove it from the URL search params
                paramKeys.forEach(function(paramKey) {
                    url.searchParams.delete(paramKey.trim());
                });
    
                // Redirect to the modified URL
                window.location.href = url.toString();
            })
        });
    }
}

function emptyValueFormFilter() {
    // https://stackoverflow.com/questions/8029532/how-to-prevent-submitting-the-html-forms-input-field-value-if-it-empty/64029534#64029534
    // remove empty value from url when submitting form
    const form = document.querySelector('.filter-form');

    if (form) {
        form.addEventListener('formdata', function(event) {
            const formData = event.formData;
            for (let [name, value] of Array.from(formData.entries())) {
                if (value === '') formData.delete(name);
            }
        });
    }
}

// FUNCTION LOAD MORE
function loadMoreAjax() {
    const button = document.querySelector('.list__loadmore')
    const loadingBtn = document.querySelector('.list__loading')
    const buttonWrapper = document.querySelector('.list__button')
    let posts_list = document.querySelector('.list__row')

    if (!button) return; // Exit function if button is not found

    if (posts_list.dataset.page == posts_list.dataset.max) {
        // button.parentNode.removeChild(button)
        buttonWrapper.classList.add('d-none')
    }

    button.addEventListener('click', (e) => {
        e.preventDefault()
        let current_page = posts_list.dataset.page

        let params = new URLSearchParams({
            action: 'load_more_activity',
            current_page: current_page,
            post_type: 'product',
            posts_per_page: 9,
            type: defaultParams.type,
            location: defaultParams.location,
            privateVilla: defaultParams.privateVilla,
            handPicked: defaultParams.handPicked,
            minPrice: defaultParams.minPrice,
            maxPrice: defaultParams.maxPrice,
            event: defaultParams.event,
            sort: defaultParams.sort,
            template_parts: 'template-parts/activity-list',
        })

        button.classList.add('d-none')
        loadingBtn.classList.add('d-inline-block')

        axios.post('/wp-admin/admin-ajax.php', params)
        .then(res => {

            console.log(res);

            posts_list.insertAdjacentHTML('beforeend', res.data.data)

            posts_list.dataset.page++ // increment dataset

            button.innerHTML = '<div class="themeBtn__inner"><span>Load More</span></div>'
            
            button.classList.remove('d-none')

            loadingBtn.classList.remove('d-inline-block')
            
            ScrollTrigger.refresh() // refresh scroll

            // check if dataset page equal to dataset max
            // if equal, remove load more button
            if (posts_list.dataset.page == posts_list.dataset.max) {
                // button.parentNode.removeChild(button)
                buttonWrapper.classList.add('d-none')
            }
        })
    })
}

function sortingActivity() {
    const formElement = document.querySelector('#sorting-form')

    const selectElement = document.querySelector('#activity-sort')

    if (selectElement) {
        selectElement.addEventListener('change', (item) => {
            formElement.submit()
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    choicesJs()
    customRangeSlider()
    removeFilter()
    emptyValueFormFilter()
    loadMoreAjax()
    sortingActivity()
})